import { apiDelete, apiGet } from '../utils/apiClient';
import { isAdminUser } from '../constants';

export default class BotsIntegrations {
    listBots(botApiUrl, tenantId, authToken) {
        const url = isAdminUser(tenantId)
            ? `${botApiUrl}/bot`
            : `${botApiUrl}/bot/my/${tenantId}`;

        return apiGet(url, { authToken });
    }

    deleteBot(botApiUrl, botId, authToken, apiKey) {
        return apiDelete(`${botApiUrl}/bot/${botId}`, {
            authToken,
            headers: { 'x-api-key': apiKey },
            parseJson: false,
        }).then(() => ({ success: true }));
    }

    deleteTenant(botApiUrl, tenantId, authToken) {
        return apiDelete(`${botApiUrl}/tenant/${tenantId}`, {
            authToken,
            parseJson: false,
        }).then(() => ({ success: true }));
    }
}
